import angular from 'angular';

const jsonInputDirective = /* @ngInject */ () => ({
	restrict: 'A',
	require: 'ngModel',
	link: (
		/** @type {any} */ scope,
		/** @type {any} */ element,
		/** @type {import('angular').IAttributes} */ attribute,
		/** @type {any} */ ctrl,
	) => {
		ctrl.$parsers.push((/** @type {string} */ input) => {
			try {
				const object = JSON.parse(input);
				ctrl.$setValidity('jsonInput', true);
				return object;
			}
			catch {
				ctrl.$setValidity('jsonInput', false);
				return undefined;
			}
		});
		ctrl.$formatters.push((/** @type {any} */ data) => {
			if (data === null) {
				ctrl.$setValidity('jsonInput', false);
				return '';
			}
			try {
				const stringValue = angular.toJson(data, true);
				ctrl.$setValidity('jsonInput', true);
				return stringValue;
			}
			catch {
				ctrl.$setValidity('jsonInput', false);
				return '';
			}
		});
	},
});

export default jsonInputDirective;
